import type { ComponentProps } from 'react'
import { Field, Text } from 'admination-react'

type CredentialFieldProps = Pick<ComponentProps<typeof Text>, 'name' | 'disabled' | 'readOnly' | 'ref'> & {
  id: string
  label: string
  type: 'email' | 'password'
  autoComplete: 'username' | 'current-password' | 'new-password'
  value: string
  onChange: (value: string) => void
}

export function CredentialField({ label, onChange, ...input }: CredentialFieldProps) {
  return <Field label={label} htmlFor={input.id}>
    <Text {...input} required inputMode={input.type === 'email' ? 'email' : undefined}
      onChange={(event) => onChange(event.target.value)} />
  </Field>
}
